import { useGetSoftwareLicencesQuery } from ".";

export const useGetSoftwareLicenceById = (id?: string) => {
  const { data } = useGetSoftwareLicencesQuery();

  //we have Basemap org. with Id=0, so make sure tho check id with undefined not like this (id ? ... : ...)
  return data?.resources.find(sl => sl.softwareLicenceId === id);
};
